export default "__VITE_ASSET__7_izNj7i__"